module.exports = __webpack_public_path__ + "static/img/cover.832f432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/cover.jpg
// module id = RT2F
// module chunks = 0